// extracted by mini-css-extract-plugin
export var bulletlist = "ParagraphChecklist-module--bulletlist--4a3d4";
export var checklist = "ParagraphChecklist-module--checklist--dad7d";
export var contentarea = "ParagraphChecklist-module--contentarea--34ee8";
export var title = "ParagraphChecklist-module--title--3bec7";